import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enText from "../assets/locales/en.json";
import myText from "../assets/locales/my.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: {
				translation: enText,
			},
			my: {
				translation: myText,
			},
		},
		fallbackLng: "my",
		supportedLngs: ["en", "my"],

		detection: {
			// Ưu tiên đọc từ localStorage trước (giữ lựa chọn cũ sau khi đổi + reload),
			// nếu chưa từng chọn thì mới fallback sang ngôn ngữ trình duyệt.
			order: ["localStorage"],
			caches: ["localStorage"],
			lookupLocalStorage: "i18nextLng",
		},

		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;